export default {
  'User': {
    collection: 'users',
    element: 'user',
    label: 'email',
    enum: {
      genders: [
        'unknown',
        'male',
        'female',
      ],
    },
    associations: {
      audits: {
        foreign_key: 'auditable_id',
        primary_key: 'id',
        class_name: 'Audited::Audit',
        polymorphic: false
      },
      application: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Application',
        polymorphic: false
      },
      creator: {
        foreign_key: 'creator_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      role: {
        foreign_key: 'role_id',
        primary_key: 'id',
        class_name: 'Role',
        polymorphic: false
      },
      avatar_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      avatar_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      user_oauth_identity_accounts: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'UserOauthIdentityAccount',
        polymorphic: false
      },
      profile: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'Profile',
        polymorphic: false
      },
      customers: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
      oauth_identity_accounts: {
        foreign_key: 'oauth_identity_account_id',
        primary_key: 'id',
        class_name: 'OauthIdentityAccount',
        polymorphic: false
      },
      users_customer_sources: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'UsersCustomerSource',
        polymorphic: false
      },
      customer_sources: {
        foreign_key: 'customer_source_id',
        primary_key: 'id',
        class_name: 'CustomerSource',
        polymorphic: false
      },
      follow_records: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'FollowRecord',
        polymorphic: false
      },
      notifications: {
        foreign_key: 'receiver_id',
        primary_key: 'id',
        class_name: 'Notification',
        polymorphic: false
      },
      memos: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'Memo',
        polymorphic: false
      },
      related_user_relations: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'RelatedUserRelation',
        polymorphic: false
      },
      related_users: {
        foreign_key: 'related_user_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      task_assignments: {
        foreign_key: 'assignee_id',
        primary_key: 'id',
        class_name: 'TaskAssignment',
        polymorphic: false
      },
      sales_orders: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'SalesOrder',
        polymorphic: false
      },
      payments: {
        foreign_key: 'creator_id',
        primary_key: 'id',
        class_name: 'Payment',
        polymorphic: false
      },
      work_reports: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'WorkReport',
        polymorphic: false
      },
      jushuitan_orders: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'JushuitanOrder',
        polymorphic: false
      },
      jushuitan_after_sales: {
        foreign_key: 'o_id',
        primary_key: 'o_id',
        class_name: 'JushuitanAfterSale',
        polymorphic: false
      },
      xiaoman_user: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'Xiaoman::User',
        polymorphic: false
      },
    }
  },
  'ActiveStorage::Attachment': {
    collection: 'activeStorage/attachments',
    element: 'activeStorage/attachment',
    label: 'name',
    enum: {
    },
    associations: {
      record: {
        foreign_key: 'record_id',
        class_name: 'Record',
        polymorphic: true
      },
      blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
  'Role': {
    collection: 'roles',
    element: 'role',
    label: 'name',
    enum: {
      kinds: [
        'super',
        'application',
        'business_executive',
        'salesman',
        'channel_business_executive',
        'finance',
        'customer_service',
        'finance_manager',
        'custom',
        'merchandiser',
      ],
    },
    associations: {
      application: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Application',
        polymorphic: false
      },
      creator: {
        foreign_key: 'creator_id',
        class_name: 'Creator',
        polymorphic: true
      },
      operatable_records: {
        foreign_key: 'operatable_id',
        primary_key: 'id',
        class_name: 'OperationRecord',
        polymorphic: false
      },
      admin_users_roles: {
        foreign_key: 'role_id',
        primary_key: 'id',
        class_name: 'AdminUsersRole',
        polymorphic: false
      },
    }
  },
  'CustomerSource': {
    collection: 'customerSources',
    element: 'customerSource',
    label: 'name',
    enum: {
    },
    associations: {
      customers: {
        foreign_key: 'customer_source_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
    }
  },
  'UserOauthIdentityAccount': {
    collection: 'userOauthIdentityAccounts',
    element: 'userOauthIdentityAccount',
    label: 'id',
    enum: {
    },
    associations: {
      user: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      oauth_identity_account: {
        foreign_key: 'oauth_identity_account_id',
        primary_key: 'id',
        class_name: 'OauthIdentityAccount',
        polymorphic: false
      },
    }
  },
  'UsersRole': {
    collection: 'usersRoles',
    element: 'usersRole',
    label: 'id',
    enum: {
    },
    associations: {
      user: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      role: {
        foreign_key: 'role_id',
        primary_key: 'id',
        class_name: 'Role',
        polymorphic: false
      },
    }
  },
  'Application': {
    collection: 'applications',
    element: 'application',
    label: 'name',
    enum: {
    },
    associations: {
      creator: {
        foreign_key: 'creator_id',
        primary_key: 'id',
        class_name: 'AdminUser',
        polymorphic: false
      },
      wechat_application: {
        foreign_key: 'wechat_application_id',
        primary_key: 'id',
        class_name: 'BsWechatMiniProgram::Application',
        polymorphic: false
      },
      pages: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Page',
        polymorphic: false
      },
      operation_records: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'OperationRecord',
        polymorphic: false
      },
      admin_users_roles: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'AdminUsersRole',
        polymorphic: false
      },
      roles: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Role',
        polymorphic: false
      },
      application_admin_users_role: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'AdminUsersRole',
        polymorphic: false
      },
      custom_pages: {
        foreign_key: 'target_id',
        primary_key: 'id',
        class_name: 'CustomPage',
        polymorphic: false
      },
      users: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      poster_image_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      poster_image_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      share_image_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      share_image_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      logo_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      logo_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
  'ActiveStorage::Blob': {
    collection: 'activeStorage/blobs',
    element: 'activeStorage/blob',
    label: 'id',
    enum: {
    },
    associations: {
      variant_records: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::VariantRecord',
        polymorphic: false
      },
      preview_image_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      preview_image_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      attachments: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'Attachment',
        polymorphic: false
      },
      taggings: {
        foreign_key: 'taggable_id',
        primary_key: 'id',
        class_name: '::ActsAsTaggableOn::Tagging',
        polymorphic: false
      },
      base_tags: {
        foreign_key: 'tag_id',
        primary_key: 'id',
        class_name: '::ActsAsTaggableOn::Tag',
        polymorphic: false
      },
      tag_taggings: {
        foreign_key: 'taggable_id',
        primary_key: 'id',
        class_name: 'ActsAsTaggableOn::Tagging',
        polymorphic: false
      },
      tags: {
        foreign_key: 'tag_id',
        primary_key: 'id',
        class_name: 'ActsAsTaggableOn::Tag',
        polymorphic: false
      },
      uploader: {
        foreign_key: 'uploader_id',
        class_name: 'Uploader',
        polymorphic: true
      },
    }
  },
  'ActsAsTaggableOn::Tag': {
    collection: 'actsAsTaggableOn/tags',
    element: 'actsAsTaggableOn/tag',
    label: 'name',
    enum: {
    },
    associations: {
      taggings: {
        foreign_key: 'tag_id',
        primary_key: 'id',
        class_name: '::ActsAsTaggableOn::Tagging',
        polymorphic: false
      },
    }
  },
  'OperationRecord': {
    collection: 'operationRecords',
    element: 'operationRecord',
    label: 'id',
    enum: {
    },
    associations: {
      application: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Application',
        polymorphic: false
      },
      operator: {
        foreign_key: 'operator_id',
        class_name: 'Operator',
        polymorphic: true
      },
      operatable: {
        foreign_key: 'operatable_id',
        class_name: 'Operatable',
        polymorphic: true
      },
    }
  },
  'Channel': {
    collection: 'channels',
    element: 'channel',
    label: 'name',
    enum: {
      order_columns: [
        'shop_id',
        'buyer_id',
        'open_id',
        'drp_co_id_from',
      ],
    },
    associations: {
      customer_channels: {
        foreign_key: 'channel_id',
        primary_key: 'id',
        class_name: 'CustomerChannel',
        polymorphic: false
      },
    }
  },
  'Customer': {
    collection: 'customers',
    element: 'customer',
    label: 'name',
    enum: {
      states: [
        'wait_to_pick',
        'picked',
        'wait_to_approve',
      ],
    },
    associations: {
      audits: {
        foreign_key: 'auditable_id',
        primary_key: 'id',
        class_name: 'Audited::Audit',
        polymorphic: false
      },
      customer_datum: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'CustomerDatum',
        polymorphic: false
      },
      taggings: {
        foreign_key: 'taggable_id',
        primary_key: 'id',
        class_name: '::ActsAsTaggableOn::Tagging',
        polymorphic: false
      },
      base_tags: {
        foreign_key: 'tag_id',
        primary_key: 'id',
        class_name: '::ActsAsTaggableOn::Tag',
        polymorphic: false
      },
      annual_status_taggings: {
        foreign_key: 'taggable_id',
        primary_key: 'id',
        class_name: 'ActsAsTaggableOn::Tagging',
        polymorphic: false
      },
      annual_status: {
        foreign_key: 'tag_id',
        primary_key: 'id',
        class_name: 'ActsAsTaggableOn::Tag',
        polymorphic: false
      },
      user: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      assign_to_user: {
        foreign_key: 'assign_to_user_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      customer_level: {
        foreign_key: 'customer_level_id',
        primary_key: 'id',
        class_name: 'CustomerLevel',
        polymorphic: false
      },
      customer_source: {
        foreign_key: 'customer_source_id',
        primary_key: 'id',
        class_name: 'CustomerSource',
        polymorphic: false
      },
      customer_kind: {
        foreign_key: 'customer_kind_id',
        primary_key: 'id',
        class_name: 'CustomerKind',
        polymorphic: false
      },
      customer_connection: {
        foreign_key: 'customer_connection_id',
        primary_key: 'id',
        class_name: 'CustomerConnection',
        polymorphic: false
      },
      customer_tags: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'CustomerTag',
        polymorphic: false
      },
      customer_transaction: {
        foreign_key: 'customer_transaction_id',
        primary_key: 'id',
        class_name: 'CustomerTransaction',
        polymorphic: false
      },
      follow_records: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'FollowRecord',
        polymorphic: false
      },
      last_follow_record: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'FollowRecord',
        polymorphic: false
      },
      last_follow_record_of_user: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'FollowRecord',
        polymorphic: false
      },
      user_customer_relations: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'UserCustomerRelation',
        polymorphic: false
      },
      customer_background_checks: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'CustomerBackgroundCheck',
        polymorphic: false
      },
      customer_jushuitan_order_relations: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'CustomerJushuitanOrderRelation',
        polymorphic: false
      },
      jushuitan_orders: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'JushuitanOrder',
        polymorphic: false
      },
      jushuitan_after_sales: {
        foreign_key: 'o_id',
        primary_key: 'o_id',
        class_name: 'JushuitanAfterSale',
        polymorphic: false
      },
      payments: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'Payment',
        polymorphic: false
      },
      sales_orders: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'SalesOrder',
        polymorphic: false
      },
      adjustments: {
        foreign_key: 'adjustable_id',
        primary_key: 'id',
        class_name: 'Adjustment',
        polymorphic: false
      },
      operation_logs: {
        foreign_key: 'target_id',
        primary_key: 'id',
        class_name: 'OperationLog',
        polymorphic: false
      },
      bill_send_records: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'BillSendRecord',
        polymorphic: false
      },
      customer_business_models: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'CustomerBusinessModel',
        polymorphic: false
      },
      product_styles: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'ProductStyle',
        polymorphic: false
      },
      sale_channels: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'SaleChannel',
        polymorphic: false
      },
      files_attachments: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      files_blobs: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
  'CustomerLevel': {
    collection: 'customerLevels',
    element: 'customerLevel',
    label: 'name',
    enum: {
    },
    associations: {
      customers: {
        foreign_key: 'customer_level_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
    }
  },
  'CustomerKind': {
    collection: 'customerKinds',
    element: 'customerKind',
    label: 'name',
    enum: {
    },
    associations: {
      customers: {
        foreign_key: 'customer_kind_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
    }
  },
  'CustomerConnection': {
    collection: 'customerConnections',
    element: 'customerConnection',
    label: 'name',
    enum: {
    },
    associations: {
      customers: {
        foreign_key: 'customer_connection_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
    }
  },
  'CustomerTag': {
    collection: 'customerTags',
    element: 'customerTag',
    label: 'name',
    enum: {
    },
    associations: {
      customers: {
        foreign_key: 'customer_tag_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
    }
  },
  'CustomerTransaction': {
    collection: 'customerTransactions',
    element: 'customerTransaction',
    label: 'name',
    enum: {
    },
    associations: {
      customers: {
        foreign_key: 'customer_transaction_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
    }
  },
  'CustomerBusinessModel': {
    collection: 'customerBusinessModels',
    element: 'customerBusinessModel',
    label: 'name',
    enum: {
    },
    associations: {
      customers: {
        foreign_key: 'customer_business_model_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
    }
  },
  'ProductStyle': {
    collection: 'productStyles',
    element: 'productStyle',
    label: 'name',
    enum: {
    },
    associations: {
      customers: {
        foreign_key: 'product_style_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
    }
  },
  'SaleChannel': {
    collection: 'saleChannels',
    element: 'saleChannel',
    label: 'name',
    enum: {
    },
    associations: {
      customers: {
        foreign_key: 'sale_channel_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
    }
  },
  'CustomerJushuitanOrderRelation': {
    collection: 'customerJushuitanOrderRelations',
    element: 'customerJushuitanOrderRelation',
    label: 'id',
    enum: {
      jushuitan_order_foreign_keys: [
        'drp_co_id_from',
        'open_id',
        'buyer_id',
        'shop_id',
        'shop_buyer_id',
      ],
    },
    associations: {
      customer: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
      jushuitan_orders: {
        foreign_key: 'key',
        primary_key: 'id',
        class_name: 'JushuitanOrder',
        polymorphic: false
      },
      jushuitan_after_sales: {
        foreign_key: 'o_id',
        primary_key: 'o_id',
        class_name: 'JushuitanAfterSale',
        polymorphic: false
      },
    }
  },
  'FollowRecord': {
    collection: 'followRecords',
    element: 'followRecord',
    label: 'id',
    enum: {
    },
    associations: {
      audits: {
        foreign_key: 'auditable_id',
        primary_key: 'id',
        class_name: 'Audited::Audit',
        polymorphic: false
      },
      user: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      customer: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
      task_assignment: {
        foreign_key: 'task_assignment_id',
        primary_key: 'id',
        class_name: 'TaskAssignment',
        polymorphic: false
      },
      follow_key_items: {
        foreign_key: 'follow_record_id',
        primary_key: 'id',
        class_name: 'FollowKeyItem',
        polymorphic: false
      },
      media_attachments: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      media_blobs: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
  'FollowKeyItem': {
    collection: 'followKeyItems',
    element: 'followKeyItem',
    label: 'name',
    enum: {
    },
    associations: {
      follow_records: {
        foreign_key: 'follow_key_item_id',
        primary_key: 'id',
        class_name: 'FollowRecord',
        polymorphic: false
      },
    }
  },
  'TaskAssignment': {
    collection: 'taskAssignments',
    element: 'taskAssignment',
    label: 'id',
    enum: {
      states: [
        'pending',
        'processing',
        'completed',
      ],
    },
    associations: {
      audits: {
        foreign_key: 'auditable_id',
        primary_key: 'id',
        class_name: 'Audited::Audit',
        polymorphic: false
      },
      task: {
        foreign_key: 'task_id',
        primary_key: 'id',
        class_name: 'Task',
        polymorphic: false
      },
      assignee: {
        foreign_key: 'assignee_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      follow_records: {
        foreign_key: 'task_assignment_id',
        primary_key: 'id',
        class_name: 'FollowRecord',
        polymorphic: false
      },
    }
  },
  'CustomerChannel': {
    collection: 'customerChannels',
    element: 'customerChannel',
    label: 'id',
    enum: {
    },
    associations: {
      customer: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
      channel: {
        foreign_key: 'channel_id',
        primary_key: 'id',
        class_name: 'Channel',
        polymorphic: false
      },
    }
  },
  'CustomerBackgroundCheck': {
    collection: 'customerBackgroundChecks',
    element: 'customerBackgroundCheck',
    label: 'id',
    enum: {
      statuses: [
        'pending',
        'processing',
        'completed',
        'failed',
      ],
    },
    associations: {
      customer: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
      submitter: {
        foreign_key: 'submitter_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
    }
  },
  'JushuitanOrder': {
    collection: 'jushuitanOrders',
    element: 'jushuitanOrder',
    label: 'id',
    enum: {
    },
    associations: {
      customer_jushuitan_order_relation: {
        foreign_key: 'key',
        primary_key: 'jushuitan_order_key',
        class_name: 'CustomerJushuitanOrderRelation',
        polymorphic: false
      },
      shop: {
        foreign_key: 'shop_id',
        primary_key: 'shop_id',
        class_name: 'JushuitanShop',
        polymorphic: false
      },
      user: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      customer: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
      jushuitan_after_sales: {
        foreign_key: 'o_id',
        primary_key: 'id',
        class_name: 'JushuitanAfterSale',
        polymorphic: false
      },
      jushuitan_inventory_outs: {
        foreign_key: 'o_id',
        primary_key: 'id',
        class_name: 'JushuitanInventoryOut',
        polymorphic: false
      },
      payment_allocations: {
        foreign_key: 'payable_id',
        primary_key: 'id',
        class_name: 'PaymentAllocation',
        polymorphic: false
      },
      adjustments: {
        foreign_key: 'adjustable_id',
        primary_key: 'id',
        class_name: 'Adjustment',
        polymorphic: false
      },
      sales_orders: {
        foreign_key: 'jushuitan_order_id',
        primary_key: 'id',
        class_name: 'SalesOrder',
        polymorphic: false
      },
    }
  },
  'JushuitanShop': {
    collection: 'jushuitanShops',
    element: 'jushuitanShop',
    label: 'id',
    enum: {
      shop_types: [
        'online',
        'offline',
      ],
    },
    associations: {
    }
  },
  'JushuitanAfterSale': {
    collection: 'jushuitanAfterSales',
    element: 'jushuitanAfterSale',
    label: 'id',
    enum: {
    },
    associations: {
      shop: {
        foreign_key: 'shop_id',
        primary_key: 'shop_id',
        class_name: 'JushuitanShop',
        polymorphic: false
      },
      order: {
        foreign_key: 'o_id',
        primary_key: 'o_id',
        class_name: 'JushuitanOrder',
        polymorphic: false
      },
      after_sale_allocations: {
        foreign_key: 'jushuitan_after_sale_id',
        primary_key: 'id',
        class_name: 'AfterSaleAllocation',
        polymorphic: false
      },
    }
  },
  'Notification': {
    collection: 'notifications',
    element: 'notification',
    label: 'id',
    enum: {
      kinds: [
        'pick_customer',
        'release_customer',
        'assign_customer',
        'pool_assign_customer',
        'apply_assign_customer',
        'cancel_apply_assign_customer',
        'approve_assign_customer',
        'reject_assign_customer',
        'fill_customer_info_remind',
        'follow_customer_remind',
        'memo_remind',
        'follow_customers_remind',
        'update_approved_payment',
        'cancel_finished_sales_order',
        'payment_remind',
        'customer_pool_opening',
        'customer_claim_followup_due',
        'customer_capacity_warning',
        'customer_claim_timeout_returned',
        'customer_release_warning',
      ],
    },
    associations: {
      receiver: {
        foreign_key: 'receiver_id',
        class_name: 'Receiver',
        polymorphic: true
      },
      actor: {
        foreign_key: 'actor_id',
        class_name: 'Actor',
        polymorphic: true
      },
      target: {
        foreign_key: 'target_id',
        class_name: 'Target',
        polymorphic: true
      },
    }
  },
  'Memo': {
    collection: 'memos',
    element: 'memo',
    label: 'id',
    enum: {
    },
    associations: {
      user: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      customer: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
    }
  },
  'CustomReport': {
    collection: 'customReports',
    element: 'customReport',
    label: 'id',
    enum: {
      kinds: [
        'monthly',
        'weekly',
        'daily',
      ],
    },
    associations: {
      target: {
        foreign_key: 'target_id',
        class_name: 'Target',
        polymorphic: true
      },
      owner: {
        foreign_key: 'owner_id',
        class_name: 'Owner',
        polymorphic: true
      },
    }
  },
  'Task': {
    collection: 'tasks',
    element: 'task',
    label: 'title',
    enum: {
    },
    associations: {
      audits: {
        foreign_key: 'auditable_id',
        primary_key: 'id',
        class_name: 'Audited::Audit',
        polymorphic: false
      },
      creator: {
        foreign_key: 'creator_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      task_assignments: {
        foreign_key: 'task_id',
        primary_key: 'id',
        class_name: 'TaskAssignment',
        polymorphic: false
      },
      assignees: {
        foreign_key: 'assignee_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
    }
  },
  'JushuitanInventoryOut': {
    collection: 'jushuitanInventoryOuts',
    element: 'jushuitanInventoryOut',
    label: 'id',
    enum: {
      kinds: [
        'sync',
        'custom',
      ],
    },
    associations: {
      shop: {
        foreign_key: 'shop_id',
        primary_key: 'shop_id',
        class_name: 'JushuitanShop',
        polymorphic: false
      },
      order: {
        foreign_key: 'o_id',
        primary_key: 'o_id',
        class_name: 'JushuitanOrder',
        polymorphic: false
      },
    }
  },
  'Payment': {
    collection: 'payments',
    element: 'payment',
    label: 'id',
    enum: {
      kinds: [
        'deposit',
        'payment',
      ],
      states: [
        'pending',
        'approved',
        'rejected',
      ],
    },
    associations: {
      audits: {
        foreign_key: 'auditable_id',
        primary_key: 'id',
        class_name: 'Audited::Audit',
        polymorphic: false
      },
      customer: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
      creator: {
        foreign_key: 'creator_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      auditor: {
        foreign_key: 'auditor_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      payment_account: {
        foreign_key: 'payment_account_id',
        primary_key: 'id',
        class_name: 'PaymentAccount',
        polymorphic: false
      },
      payment_allocations: {
        foreign_key: 'payment_id',
        primary_key: 'id',
        class_name: 'PaymentAllocation',
        polymorphic: false
      },
      image_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      image_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
  'PaymentAccount': {
    collection: 'paymentAccounts',
    element: 'paymentAccount',
    label: 'name',
    enum: {
      states: [
        'active',
        'inactive',
      ],
    },
    associations: {
      audits: {
        foreign_key: 'auditable_id',
        primary_key: 'id',
        class_name: 'Audited::Audit',
        polymorphic: false
      },
      payments: {
        foreign_key: 'payment_account_id',
        primary_key: 'id',
        class_name: 'Payment',
        polymorphic: false
      },
    }
  },
  'PaymentAllocation': {
    collection: 'paymentAllocations',
    element: 'paymentAllocation',
    label: 'id',
    enum: {
    },
    associations: {
      audits: {
        foreign_key: 'auditable_id',
        primary_key: 'id',
        class_name: 'Audited::Audit',
        polymorphic: false
      },
      payable: {
        foreign_key: 'payable_id',
        class_name: 'Payable',
        polymorphic: true
      },
      payment: {
        foreign_key: 'payment_id',
        primary_key: 'id',
        class_name: 'Payment',
        polymorphic: false
      },
    }
  },
  'Adjustment': {
    collection: 'adjustments',
    element: 'adjustment',
    label: 'id',
    enum: {
    },
    associations: {
      audits: {
        foreign_key: 'auditable_id',
        primary_key: 'id',
        class_name: 'Audited::Audit',
        polymorphic: false
      },
      adjustable: {
        foreign_key: 'adjustable_id',
        class_name: 'Adjustable',
        polymorphic: true
      },
      creator: {
        foreign_key: 'creator_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
    }
  },
  'SalesOrder': {
    collection: 'salesOrders',
    element: 'salesOrder',
    label: 'id',
    enum: {
      kinds: [
        'sample',
        'bulk',
        'after_sale',
      ],
      product_types: [
        'custom',
        'stock',
      ],
      business_kinds: [
        'custom',
        'wholesale',
      ],
    },
    associations: {
      audits: {
        foreign_key: 'auditable_id',
        primary_key: 'id',
        class_name: 'Audited::Audit',
        polymorphic: false
      },
      user: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      customer: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
      source: {
        foreign_key: 'source_id',
        primary_key: 'id',
        class_name: 'SalesOrder',
        polymorphic: false
      },
      sales_line_items: {
        foreign_key: 'sales_order_id',
        primary_key: 'id',
        class_name: 'SalesLineItem',
        polymorphic: false
      },
      payment_reminders: {
        foreign_key: 'sales_order_id',
        primary_key: 'id',
        class_name: 'PaymentReminder',
        polymorphic: false
      },
      jushuitan_orders: {
        foreign_key: 'sales_order_id',
        primary_key: 'id',
        class_name: 'JushuitanOrder',
        polymorphic: false
      },
      sent_jushuitan_orders: {
        foreign_key: 'sales_order_id',
        primary_key: 'id',
        class_name: 'JushuitanOrder',
        polymorphic: false
      },
      jushuitan_after_sales: {
        foreign_key: 'o_id',
        primary_key: 'o_id',
        class_name: 'JushuitanAfterSale',
        polymorphic: false
      },
      confirmed_jushuitan_after_sales: {
        foreign_key: 'o_id',
        primary_key: 'o_id',
        class_name: 'JushuitanAfterSale',
        polymorphic: false
      },
      payment_allocations: {
        foreign_key: 'payable_id',
        primary_key: 'id',
        class_name: 'PaymentAllocation',
        polymorphic: false
      },
      payment_allocations_from_jushuitan_orders: {
        foreign_key: 'payable_id',
        primary_key: 'id',
        class_name: 'PaymentAllocation',
        polymorphic: false
      },
      adjustments: {
        foreign_key: 'adjustable_id',
        primary_key: 'id',
        class_name: 'Adjustment',
        polymorphic: false
      },
      adjustments_from_jushuitan_orders: {
        foreign_key: 'adjustable_id',
        primary_key: 'id',
        class_name: 'Adjustment',
        polymorphic: false
      },
      sales_order_allocations_as_source: {
        foreign_key: 'source_id',
        primary_key: 'id',
        class_name: 'SalesOrderAllocation',
        polymorphic: false
      },
      sales_order_allocations_as_target: {
        foreign_key: 'target_id',
        primary_key: 'id',
        class_name: 'SalesOrderAllocation',
        polymorphic: false
      },
      after_sale_allocations: {
        foreign_key: 'sales_order_id',
        primary_key: 'id',
        class_name: 'AfterSaleAllocation',
        polymorphic: false
      },
    }
  },
  'PaymentReminder': {
    collection: 'paymentReminders',
    element: 'paymentReminder',
    label: 'id',
    enum: {
      states: [
        'pending',
        'received',
        'overdue',
      ],
    },
    associations: {
      audits: {
        foreign_key: 'auditable_id',
        primary_key: 'id',
        class_name: 'Audited::Audit',
        polymorphic: false
      },
      sales_order: {
        foreign_key: 'sales_order_id',
        primary_key: 'id',
        class_name: 'SalesOrder',
        polymorphic: false
      },
    }
  },
  'SalesLineItem': {
    collection: 'salesLineItems',
    element: 'salesLineItem',
    label: 'id',
    enum: {
    },
    associations: {
      audits: {
        foreign_key: 'auditable_id',
        primary_key: 'id',
        class_name: 'Audited::Audit',
        polymorphic: false
      },
      sales_order: {
        foreign_key: 'sales_order_id',
        primary_key: 'id',
        class_name: 'SalesOrder',
        polymorphic: false
      },
      jushuitan_sku: {
        foreign_key: 'style_number',
        primary_key: 'i_id',
        class_name: 'JushuitanSKU',
        polymorphic: false
      },
      feige_product: {
        foreign_key: 'style_number',
        primary_key: 'style_number',
        class_name: 'Feige::Product',
        polymorphic: false
      },
    }
  },
  'SalesOrderAllocation': {
    collection: 'salesOrderAllocations',
    element: 'salesOrderAllocation',
    label: 'id',
    enum: {
    },
    associations: {
      audits: {
        foreign_key: 'auditable_id',
        primary_key: 'id',
        class_name: 'Audited::Audit',
        polymorphic: false
      },
      source: {
        foreign_key: 'source_id',
        primary_key: 'id',
        class_name: 'SalesOrder',
        polymorphic: false
      },
      target: {
        foreign_key: 'target_id',
        primary_key: 'id',
        class_name: 'SalesOrder',
        polymorphic: false
      },
    }
  },
  'AfterSaleAllocation': {
    collection: 'afterSaleAllocations',
    element: 'afterSaleAllocation',
    label: 'id',
    enum: {
    },
    associations: {
      sales_order: {
        foreign_key: 'sales_order_id',
        primary_key: 'id',
        class_name: 'SalesOrder',
        polymorphic: false
      },
      jushuitan_after_sale: {
        foreign_key: 'jushuitan_after_sale_id',
        primary_key: 'id',
        class_name: 'JushuitanAfterSale',
        polymorphic: false
      },
    }
  },
  'Feige::Product': {
    collection: 'feige/products',
    element: 'feige/product',
    label: 'name',
    enum: {
    },
    associations: {
    }
  },
  'WorkReport': {
    collection: 'workReports',
    element: 'workReport',
    label: 'id',
    enum: {
    },
    associations: {
      audits: {
        foreign_key: 'auditable_id',
        primary_key: 'id',
        class_name: 'Audited::Audit',
        polymorphic: false
      },
      user: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      files_attachments: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      files_blobs: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
  'Reports::Receivable': {
    collection: 'reports/receivables',
    element: 'reports/receivable',
    label: 'name',
    enum: {
    },
    associations: {
      user: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      customer_source: {
        foreign_key: 'customer_source_id',
        primary_key: 'id',
        class_name: 'CustomerSource',
        polymorphic: false
      },
      latest_jushuitan_order: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'JushuitanOrder',
        polymorphic: false
      },
      sales_orders: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'SalesOrder',
        polymorphic: false
      },
      jushuitan_orders: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'JushuitanOrder',
        polymorphic: false
      },
      jushuitan_after_sales: {
        foreign_key: 'o_id',
        primary_key: 'o_id',
        class_name: 'JushuitanAfterSale',
        polymorphic: false
      },
      related_jushuitan_orders: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'JushuitanOrder',
        polymorphic: false
      },
      related_jushuitan_after_sales: {
        foreign_key: 'o_id',
        primary_key: 'o_id',
        class_name: 'JushuitanAfterSale',
        polymorphic: false
      },
      related_sales_orders: {
        foreign_key: 'sales_order_id',
        primary_key: 'id',
        class_name: 'SalesOrder',
        polymorphic: false
      },
      payments: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'Payment',
        polymorphic: false
      },
      latest_bill_send_record: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'BillSendRecord',
        polymorphic: false
      },
    }
  },
  'Reports::CommissionSource': {
    collection: 'reports/commissionSources',
    element: 'reports/commissionSource',
    label: 'email',
    enum: {
    },
    associations: {
      role: {
        foreign_key: 'role_id',
        primary_key: 'id',
        class_name: 'Role',
        polymorphic: false
      },
      sales_orders: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'Reports::CommissionSourceSalesOrder',
        polymorphic: false
      },
      jushuitan_orders: {
        foreign_key: 'jushuitan_order_id',
        primary_key: 'id',
        class_name: 'JushuitanOrder',
        polymorphic: false
      },
      jushuitan_after_sales: {
        foreign_key: 'o_id',
        primary_key: 'o_id',
        class_name: 'JushuitanAfterSale',
        polymorphic: false
      },
    }
  },
  'Reports::CommissionSourceSalesOrder': {
    collection: 'reports/commissionSourceSalesOrders',
    element: 'reports/commissionSourceSalesOrder',
    label: 'id',
    enum: {
      kinds: [
        'sample',
        'bulk',
        'after_sale',
      ],
      product_types: [
        'custom',
        'stock',
      ],
      business_kinds: [
        'custom',
        'wholesale',
      ],
    },
    associations: {
      audits: {
        foreign_key: 'auditable_id',
        primary_key: 'id',
        class_name: 'Audited::Audit',
        polymorphic: false
      },
      user: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      customer: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
      source: {
        foreign_key: 'source_id',
        primary_key: 'id',
        class_name: 'SalesOrder',
        polymorphic: false
      },
      sales_line_items: {
        foreign_key: 'sales_order_id',
        primary_key: 'id',
        class_name: 'SalesLineItem',
        polymorphic: false
      },
      payment_reminders: {
        foreign_key: 'sales_order_id',
        primary_key: 'id',
        class_name: 'PaymentReminder',
        polymorphic: false
      },
      jushuitan_orders: {
        foreign_key: 'sales_order_id',
        primary_key: 'id',
        class_name: 'JushuitanOrder',
        polymorphic: false
      },
      sent_jushuitan_orders: {
        foreign_key: 'sales_order_id',
        primary_key: 'id',
        class_name: 'JushuitanOrder',
        polymorphic: false
      },
      jushuitan_after_sales: {
        foreign_key: 'o_id',
        primary_key: 'o_id',
        class_name: 'JushuitanAfterSale',
        polymorphic: false
      },
      confirmed_jushuitan_after_sales: {
        foreign_key: 'o_id',
        primary_key: 'o_id',
        class_name: 'JushuitanAfterSale',
        polymorphic: false
      },
      payment_allocations: {
        foreign_key: 'payable_id',
        primary_key: 'id',
        class_name: 'PaymentAllocation',
        polymorphic: false
      },
      payment_allocations_from_jushuitan_orders: {
        foreign_key: 'payable_id',
        primary_key: 'id',
        class_name: 'PaymentAllocation',
        polymorphic: false
      },
      adjustments: {
        foreign_key: 'adjustable_id',
        primary_key: 'id',
        class_name: 'Adjustment',
        polymorphic: false
      },
      adjustments_from_jushuitan_orders: {
        foreign_key: 'adjustable_id',
        primary_key: 'id',
        class_name: 'Adjustment',
        polymorphic: false
      },
      sales_order_allocations_as_source: {
        foreign_key: 'source_id',
        primary_key: 'id',
        class_name: 'SalesOrderAllocation',
        polymorphic: false
      },
      sales_order_allocations_as_target: {
        foreign_key: 'target_id',
        primary_key: 'id',
        class_name: 'SalesOrderAllocation',
        polymorphic: false
      },
      after_sale_allocations: {
        foreign_key: 'sales_order_id',
        primary_key: 'id',
        class_name: 'AfterSaleAllocation',
        polymorphic: false
      },
    }
  },
  'PerformanceGoal': {
    collection: 'performanceGoals',
    element: 'performanceGoal',
    label: 'id',
    enum: {
      goal_types: [
        'monthly',
        'weekly',
        'half_yearly',
      ],
    },
    associations: {
      audits: {
        foreign_key: 'auditable_id',
        primary_key: 'id',
        class_name: 'Audited::Audit',
        polymorphic: false
      },
      user: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      creator: {
        foreign_key: 'creator_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
    }
  },
  'Team': {
    collection: 'teams',
    element: 'team',
    label: 'name',
    enum: {
      kinds: [
        'normal',
        'purple',
        'golden',
      ],
    },
    associations: {
      leader: {
        foreign_key: 'leader_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      merchandiser: {
        foreign_key: 'merchandiser_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      parent: {
        foreign_key: 'parent_id',
        primary_key: 'id',
        class_name: 'Team',
        polymorphic: false
      },
      children: {
        foreign_key: 'parent_id',
        primary_key: 'id',
        class_name: 'Team',
        polymorphic: false
      },
      team_members: {
        foreign_key: 'team_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
    }
  },
  'OperationLog': {
    collection: 'operationLogs',
    element: 'operationLog',
    label: 'id',
    enum: {
    },
    associations: {
      operator: {
        foreign_key: 'operator_id',
        class_name: 'Operator',
        polymorphic: true
      },
      target: {
        foreign_key: 'target_id',
        class_name: 'Target',
        polymorphic: true
      },
    }
  },
  'BillSendRecord': {
    collection: 'billSendRecords',
    element: 'billSendRecord',
    label: 'id',
    enum: {
      states: [
        'pending',
        'confirmed',
      ],
    },
    associations: {
      audits: {
        foreign_key: 'auditable_id',
        primary_key: 'id',
        class_name: 'Audited::Audit',
        polymorphic: false
      },
      customer: {
        foreign_key: 'customer_id',
        primary_key: 'id',
        class_name: 'Customer',
        polymorphic: false
      },
      sender: {
        foreign_key: 'sender_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      confirmed_by: {
        foreign_key: 'confirmed_by_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      file_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      file_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
}
